import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map, take } from 'rxjs/operators';

export const guestGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    return authService.isAuthenticated$.pipe(
        take(1),
        map(isAuthenticated => {
            if (!isAuthenticated) {
                return true;
            } else {
                // Redirect based on role
                const role = authService.getRole();
                if (role === 'ASSISTANT') {
                    router.navigate(['/assistant-cases']);
                } else {
                    router.navigate(['/dashboard']);
                }
                return false;
            }
        })
    );
};
